import { FieldSet } from '@acorn-portal/shared/src/components/fieldSet';
import RadioGroupButton from '@acorn-portal/shared/src/components/inputs/radio-button-group';
import { useFormikContext } from 'formik';
import { FC } from 'react';
import { IRenewalMakePaymentForm } from '@acorn-portal/shared/src/pages/renewal/MakePayment';

export interface IAffordabilityLendingQuestionsValues {
	premiumConfirm?: 'yes' | 'no';
	affordable?: 'yes' | 'no';
}

export const AffordabilityLendingQuestions: FC = () => {
	const formik = useFormikContext<IRenewalMakePaymentForm>();
	const financedPolicy = import.meta.env.VITE_AUTH_REALM !== 'Motorcade';

	return (
		<FieldSet title={financedPolicy ? 'Finance Details' : 'Affordability'}>
			{financedPolicy && (
				<RadioGroupButton
					value={formik.values.premiumConfirm}
					name='premiumConfirm'
					id='premiumConfirm'
					onChange={(value) => {
						formik.setFieldTouched('premiumConfirm', true, false);
						formik.setFieldValue('premiumConfirm', value);
					}}
					error={formik.touched.premiumConfirm && Boolean(formik?.errors?.premiumConfirm)}
					helperText={formik?.touched?.premiumConfirm && formik?.errors?.premiumConfirm}
					label='By selecting to pay your policy premium monthly, you are applying for premium finance. Please confirm that you wish to obtain premium finance and pay your policy monthly?'
				/>
			)}

			<RadioGroupButton
				value={formik.values.affordable}
				name='affordable'
				id='affordable'
				onChange={(value) => {
					formik.setFieldTouched('affordable', true, false);
					formik.setFieldValue('affordable', value);
				}}
				error={formik.touched.affordable && Boolean(formik?.errors?.affordable)}
				helperText={formik?.touched.affordable && formik?.errors?.affordable}
				label='Do you consider that the monthly payment is affordable to you now and for the duration of the agreement?'
			/>
		</FieldSet>
	);
};

export default AffordabilityLendingQuestions;
